import React, {useMemo} from 'react';
import {MobileRectangleTableTop} from "./top";
import {MobileRectangleTableBottom} from "./bottom";
import {doChipStore} from "../../../store/doChipStore";
import {useRouletteDoBetValidation} from "../../../hooks/useRouletteDoBetValidation";
import {REC_BET_DATA_MODEL_MAP} from "../../../enums/tableNumbers";
import {observer} from "mobx-react-lite";
import {useChip} from "../../../hooks/useChip";
import {winningAmountStore} from "../../../store/winningAmountStore";

export const MobileRectangleTable = observer(() => {
  const {selectedChip} = doChipStore;
  const {handleDoBetWithValid} = useRouletteDoBetValidation();
  const {handleGetColumnChip, memoAllChipsTypes} = useChip();
  const { winNumber } = winningAmountStore;

  const handleDoChip = e => {
    const valueType = e.target.getAttribute("data");
    const model = REC_BET_DATA_MODEL_MAP[valueType];
    if (model) {
      const nextChipModel = {
        [model.type]: selectedChip,
        chipType: model.type,
      };
      if (selectedChip) {
        handleDoBetWithValid(nextChipModel);
      }
    }
  };
  return (
    <div className="mob-roulette-t-inside" onClick={handleDoChip}>
      <MobileRectangleTableBottom
        allChipsTypes={memoAllChipsTypes}
        handleGetColumnChip={handleGetColumnChip}
      />
      <MobileRectangleTableTop
        winNumber={winNumber}
        memoAllChipsTypes={memoAllChipsTypes}
        handleGetColumnChip={handleGetColumnChip}
      />
    </div>
  );
});
